<template>
  <div id="layout">
    <el-container>
      <el-header class="header">
        <layoutHeader></layoutHeader>
      </el-header>
      <el-container>
        <el-aside class="aside">
          <layoutAside></layoutAside>
        </el-aside>
        <el-main class="main">
          <el-header class="tabNav">
            <TabNav></TabNav>
          </el-header>
          <el-main class="manIndex">
            <transition name="content" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-main>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import layoutAside from './aside/aside.vue'
import layoutHeader from './header/header'
import Bottom from './Footer/bottom'
import TabNav from './header/tabNav.vue'

export default {
  name: 'dc-home',
  components: {
    layoutHeader,
    Bottom,
    layoutAside,
    TabNav
  }
}


</script>
<style lang="scss" scoped>
* {
  margin: 0px;
  padding: 0px;
}
/deep/ .el-main{
  padding: 0 !important;
}
#layout {
  width: 100%;
  height: 100%;

  .el-container.is-vertical {
    width: 100%;
    height: 100%;
  }

  .header {
    width: 100%;
    height: 70px !important;
    background-color: #356fa9;
    padding: 0 !important;
  }

 .aside {
    width: auto !important;
    height: calc(100vh - 70px);
  }

  .main {
    height: calc(100vh - 70px);
    width: auto;
    padding: 0 !important;

    .tabNav {
      width: 100%;
      height: 40px !important;
      background-color: #d5d5d5;
    }

    .manIndex {
      width: 100%;
      height: calc(100% - 40px);
      background-color: #ebeaea;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-x: hidden !important;
    }
  }
}

.content-enter-active,
.content-leave-active {
  transition: opacity 0.5s !important;

}

.content-enter-active {
  transition-delay: 0.5s;
}

.content-enter,
.content-leave-to {
  opacity: 0 !important;
}</style>



// WEBPACK FOOTER //
// src/system/index/layout/layout.vue